import { Check } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { TERMS_UPDATED, TERMS_INTRO, TERMS_SECTIONS } from "../data/terms";

const Bullets = ({ items }) => (
  <ul className="mt-3 space-y-2.5">
    {items.map((b, i) => (
      <li key={i} className="flex items-start gap-3 text-[15px] text-[#AEBFD8] leading-relaxed">
        <Check size={16} className="text-[#45E0B5] mt-1 shrink-0" />
        <span>{b}</span>
      </li>
    ))}
  </ul>
);

export default function TermsPage() {
  return (
    <div className="pt-28 md:pt-32 px-5 md:px-10 pb-10 md:pb-16">
      <div className="max-w-[980px] mx-auto">
        <Reveal>
          <div className="glass-panel px-6 py-12 md:px-14 md:py-16">
            <header className="mb-10">
              <p className="text-xs font-bold tracking-[0.22em] text-[#39D5FF] mb-4">LEGAL</p>
              <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#F7FAFF]">
                Terms &amp; <span className="text-gradient">Conditions.</span>
              </h1>
              <p className="mt-4 text-sm text-[#7F92AE]">Last updated: {TERMS_UPDATED}</p>
            </header>

            <div className="space-y-4 mb-12">
              {TERMS_INTRO.map((p, i) => (
                <p key={i} className="text-[15px] md:text-base text-[#AEBFD8] leading-relaxed">{p}</p>
              ))}
            </div>

            <div className="space-y-12">
              {TERMS_SECTIONS.map((s) => (
                <section key={s.title} data-testid="terms-section">
                  <h2 className="text-xl md:text-2xl font-bold text-[#F7FAFF] tracking-tight mb-3 pl-4 border-l-2 border-[rgba(65,176,255,0.65)]">
                    {s.title}
                  </h2>
                  {s.paras?.map((p, i) => (
                    <p key={i} className="text-[15px] md:text-base text-[#AEBFD8] leading-relaxed mt-3">{p}</p>
                  ))}
                  {s.bullets && <Bullets items={s.bullets} />}

                  {s.subsections?.map((sub) => (
                    <div key={sub.heading} className="mt-5">
                      <h3 className="text-base md:text-lg font-semibold text-[#39D5FF] mb-2">{sub.heading}</h3>
                      {sub.paras.map((p, i) => (
                        <p key={i} className="text-[15px] md:text-base text-[#AEBFD8] leading-relaxed">{p}</p>
                      ))}
                    </div>
                  ))}

                  {s.contact && (
                    <div className="glass-card mt-5 p-5 text-[15px] text-[#AEBFD8] leading-relaxed">
                      <p className="font-bold text-[#F7FAFF]">{s.contact.name}</p>
                      <p>{s.contact.address}</p>
                      <p className="mt-1">Email: <a href={`mailto:${s.contact.email}`} className="text-[#39D5FF] hover:underline">{s.contact.email}</a></p>
                      <p>Website: <a href={s.contact.website} target="_blank" rel="noopener noreferrer" className="text-[#39D5FF] hover:underline">{s.contact.website}</a></p>
                    </div>
                  )}
                </section>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
